<template>
  <div>
    <el-row style="margin: 10px 0">
      <el-col :span="24">
        <el-card>
          <slot name="buttons"></slot>

          <div style="float: right">
            <!-- <Dropdown style="margin-left: 20px" v-if="isExport">
                <Button icon="ios-download-outline" type="primary">
                  数据导出
                  <Icon type="ios-arrow-down"></Icon>
                </Button>
                <DropdownMenu slot="list">
                  <DropdownItem>导出选中</DropdownItem>
                  <DropdownItem divided>全部导出</DropdownItem>
                </DropdownMenu>
            </Dropdown>-->
            <slot name="mark"></slot>
          </div>

          <div>
            <el-table
              ref="tablesMain"
              :data="insideTableData"
              @select="onSelectionChange"
              border
            >
              <slot name="columns"></slot>
            </el-table>
          </div>
          <div style="text-align: center; margin-top: 15px" v-if="isPage">
            <el-pagination
              :total="tableShow.listCount"
              :current-page.sync="tableShow.currentPage"
              background
              layout="total, sizes, prev, pager, next"
              :page-size.sync="tableShow.pageSize"
              :page-sizes="tableShow.pageOpts"
              :hide-on-single-page="false"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="delModal" title="删除提示" width="35%">
      <el-alert :title="delMsg" type="warning" :closable="false"></el-alert>
      <div slot="footer">
        <el-button
          type="danger"
          plain
          style="margin-right: 8px"
          @click="
            delModal = false;
            delLoading = false;
          "
          >取消</el-button
        >
        <el-button type="primary" :loading="delLoading" @click="doDel"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Db from "@/api/db";
let db;
export default {
  name: "DataTable",
  props: {
    // 异步请求url
    listUrl: {
      type: String,
    },
    // 是否需要分页
    isPage: {
      type: Boolean,
      default: true,
    },
    // 删除地址
    delUrl: {
      type: String,
    },
    // 搜索参数
    search: {
      type: Object,
      default() {
        return {};
      },
    },
    isExport: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default() {
        return 0;
      },
    },
    minWidth: {
      type: Number,
      default: 1050,
    },
    urlParams: {
      type: Object,
      default: () => {},
    },
    delMsg: {
      type: String,
      default: "所选数据将从列表中删除，是否确认删除数据？",
    },
  },
  /**
   * Events
   * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
   * @on-cancel-edit 返回值 {Object} 同上
   * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
   */
  data() {
    return {
      length: 0, //记录每页过来的数据长度，做删除的时候是否进行当前页面数据保留使用

      insideTableData: [],
      loading: true,
      // selectIds: [], // 多选
      singleid: null, // 单选删除id
      params: {}, // url 传过来的参数
      delModal: false,
      delLoading: false,
      tableShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0,
        pageOpts: [10, 30, 50, 100, 500, 1000],
      },
    };
  },
  methods: {
    /**
     * 删除前置，弹出确认窗口
     */
    doDelete(id) {
      if (id > 0) {
        this.singleid = id;
      } else {
        this.$message.warning("参数错误！");
        return;
      }
      this.delModal = true;
    },

    /**
     * 删除操作
     * @return {[type]} [description]
     */
    doDel() {
      this.delLoading = true;

      let del_id = [];
      this.selectIds = [];
      del_id[0] = this.singleid;

      db.post(this.delUrl, { ids: del_id }).then((res) => {
        this.delLoading = false;
        if (res && res.code == 200) {
          this.singleid = null;
          this.delModal = false;
          this.loading = true;

          this.selectIds = [];
          // this.$emit("deleteBack"); //删除的回调
          this.$message.success(res.msg);

          this.reloadData();
        }
      });
    },

    /**
     * 刷新数据，保持在当前页面
     */
    reloadData() {
      this.loading = true;
      db.setSearch(this.search);

      if (this.isPage) {
        db.setPage(this.tableShow.currentPage);
        db.setPageSize(this.tableShow.pageSize);
      }

      this.getData();
    },

    /**
     * 刷新表格
     */
    reloadTable() {
      // 加载状态
      this.loading = true;
      db.setSearch(this.search);
      // 发起请求
      this.getData();
    },

    /**
     * 点击页码触发
     * @param  {[type]} page [description]
     * @return {[type]}      [description]
     */
    handlePageChange(page) {
      this.loading = true;
      // this.selectIds = [];
      this.tableShow.currentPage = page;
      db.setPage(page);
      db.setPageSize(this.tableShow.pageSize);
      db.setSearch(this.search);
      this.getData();
      this.$emit("changePageBack");
    },
    /**
     * 改变每页显示条数
     * @return {[type]} [description]
     */
    handleSizeChange(pageSize) {
      this.loading = true;
      this.tableShow.pageSize = pageSize;
      this.tableShow.currentPage = 1; // 每页条数切换后，当前页码置为1
      db.setPage(1);
      db.setPageSize(pageSize);
      // db.setSearch(this.search);
      this.getData();
    },

    /**
     * 搜索触发
     * @return {[type]} [description]
     */
    handleSearch() {
      // 加载状态
      // this.loading = true;
      // this.selectIds = [];
      //点击搜索重置页码
      this.tableShow.currentPage = 1;
      db.setPage(1);
      // 搜索条件
      // db.setSearch(this.search);
      // 发起请求
      this.getData();
      this.$emit("searchBack"); //切换页码的回调
    },

    /**
     * 多选操作
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelectionChange(selection) {
      this.$emit("getTableSeleted", selection);
      // // 多选，计算ID
      // let selected = [];
      // for (var key in selection) {
      //   selected.push(selection[key][this.selectIdKey]);
      // }

      // if (selected.length > 0) {
      //   this.selectIds = selected;
      // } else {
      //   this.selectIds = [];
      // }
    },

    /**
     * 导出选中
     * @param  {[type]} name [description]
     * @return {[type]}      [description]
     */
    exportSelected(callback) {
      this.$parent[callback]();
    },

    //获取表格数据
    getData(ifFirst = false) {
      // 发起请求
      if (ifFirst) {
        db = new Db();
      }

      let params = {};

      if (this.urlParams && JSON.stringify(this.urlParams) != "{}") {
        Object.assign(params, this.urlParams);
      }

      db.list(this.listUrl, { params, search: this.search }, this.isPage).then(
        (resp) => {
          this.loading = false;
          if (resp && resp.code == 200) {
            if (this.isPage) {
              this.insideTableData = resp.data.data;
              this.length = resp.data.data.length;
              this.tableShow.listCount = resp.data.total;
            } else {
              this.insideTableData = resp.data;
            }
            if (ifFirst) {
              this.$emit("getFirstDataBack", resp.data);
            }
          }
          this.$emit("getTableData", resp.data);
        }
      );
    },
  },
  mounted() {
    this.getData(true);
  },
  /**防止keep-alive造成的数据不刷新**/
  activated() {
    this.getData(true);
  },
  watch: {
    insideTableData(value) {
      this.$emit("input", value);
    },
    // selectIds: {
    //   handler: function(val) {
    //     if (val && val.length === 0) {
    //       this.disabled = true;
    //     } else {
    //       this.disabled = false;
    //     }
    //   },
    //   deep: true
    // }
  },
};
</script>
<style scoped>
.tables {
  min-width: 1050px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/dataTable.vue